export const carouselData = [
  {
    prompt: "乡村风景",
    style: "风格：油画",
    artist: "艺术家：梵高 ",
    image: "https://nolipix-web.oss-cn-hangzhou.aliyuncs.com/assets/creator/Onboarding/1.png",
  },
  {
    prompt: "黄色牡丹花",
    style: "风格：水彩画",
    artist: "生成循环纹样",
    image: "https://nolipix-web.oss-cn-hangzhou.aliyuncs.com/assets/creator/Onboarding/2.png",
  },
  {
    prompt: "赛博朋克城市",
    style: "风格：赛博朋克",
    image: "https://nolipix-web.oss-cn-hangzhou.aliyuncs.com/assets/creator/Onboarding/3.png",
  },
  {
    prompt: "山上的城堡",
    style: "艺术家：宫崎骏",
    image: "https://nolipix-web.oss-cn-hangzhou.aliyuncs.com/assets/creator/Onboarding/4.png",
  },
  {
    prompt: "棕色头发少女",
    style: "风格：动漫",
    artist: "艺术家：穆夏",
    comic: "动漫模型生成",
    image: "https://nolipix-web.oss-cn-hangzhou.aliyuncs.com/assets/creator/Onboarding/5.png",
  },
  {
    prompt: "火星城市",
    style: "风格：史诗",
    image: "https://nolipix-web.oss-cn-hangzhou.aliyuncs.com/assets/creator/Onboarding/6.png",
  },
];
